import { useQuery } from "react-query";
import { useParams } from "react-router-dom";
import API from "../../../services/API";
import useReorderChoices from "./useReorderChoices";

export default function useChoices(){

    const {quizId} = useParams()

    const reorderChoices = useReorderChoices()

    return useQuery({

        queryKey: ['design', quizId, 'choices'],

        queryFn: () => API.get(`/design/sections/${quizId}/choices`)
            .then(r => reorderChoices(r.data)),

        staleTime: 'Infinity',
        refetchInterval: false,
        refetchIntervalInBackground: false,
        refetchOnMount: false,
        refetchOnReconnect: false,
        refetchOnWindowFocus: false,
    })
};